/*
 * Copyright (c) 2023. Haodong JU
 */

import GlobalSettings from '@/model/global/GlobalSettings'

import hillo from 'hillo'
import Section from '@/model/dataLayer/api/tableAndPerson/Section'
import IKDataEntity from '@/plugins/EntityFrameWork/IKDataEntity'
// import store from '../store'

const entity = {
  id: {
    type: IKDataEntity.Types.Integer,
    displayName: 'id',
    tableConfig: {
      align: 'start'
    },
    form: false,
    header: false
  },
  name: {
    displayName: 'tableNumber'
  },
  description: {
    formConfig: {
      required: false
    }
  },
  tableType: {
    type: IKDataEntity.Types.Option,
    formConfig: {
      type: {
        selectItems: async () => {
          return tableType
        },
        itemText: 'label',
        itemValue: 'value'
      }
    }
  },
  pricePer15Min: {},
  minConsumePrice: {},
  sectionId: {
    displayName: 'sectionName',
    type: IKDataEntity.Types.Option,
    formConfig: {
      type: {
        selectItems: Section.getList,
        itemText: 'name'
      }
    }
  },
  seatCount: {
    formConfig: {
      hint: 'the_max_number_of_reserved_customer_at_this_table', // 在本桌接受预定时,最多可以容纳多少个人
      default: 4
    }
  }
}
const config = {
  add: function (item) {
    return hillo.postWithUploadFile('Tables.php?op=add', item, {
      showLoading: true
    })
  },
  edit: function (item) {
    return hillo.postWithUploadFile('Tables.php?op=update', item)
  },
  remove: function (id) {
    return hillo.post('Tables.php?op=delete', { id })
  },
  load: async function (filter) {
    return (await hillo.get('Tables.php', {
      op: 'currentInfos',
      lang: GlobalSettings.getLang(),
      ...filter
    })).content.filter(it => parseInt(it.sectionId) !== 6)
  }
}

export default IKDataEntity.ModelFactory(entity, config)

export const getAllTableList = async function () {
  return (await hillo.get('Tables.php', {
    op: 'currentInfos'
  })).content
}

export const tableType = [
  {
    label: 'Table',
    value: 'Table'
  },
  {
    label: 'Room',
    value: 'Room'
  }
]
